import { useTranslation as useOriginalTranslation } from 'react-i18next';
import { translate } from './i18n';

export function useTranslation(ns?: string) {
    const { i18n } = useOriginalTranslation(ns);

    return {
        t: translate,
        i18n,
    };
}
